import { useState, useEffect, Fragment } from "react";
import Skeleton from "@mui/material/Skeleton";
import TiposPedido from "../../util/typesTipoPedido";
import AnexarComprovante from "../AnexarComprovante";
import { Grid, Typography, Box, Divider, Badge, Link } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ListItemText from "@mui/material/ListItemText";
import Modal from "../Modal/Modal";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { useQuery } from "react-query";
import { PEDIDOCOMPROVANTES } from "../../util/typesReactQuery";
import { useAuth } from "../../hooks/AuthContext";
import useAlert from "../../hooks/useAlert";
import useStyles from "./styles";
import { getComprovantePedidoByIDPedido } from "../../api/Cambio";
import CancelarPedidoCambio from "../CancelaPedidoCambio";
import EdicaoFormaPagamento from "../EdicaoFormaPagamento";
import FormasPagamentoSelecionado from "../PedidoConcluidoPagamentoEscolhidoSeguroViagem";
import TipoStatusPedido from "../../util/typesTipoStatusPedido";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { format } from "date-fns";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import Delivery from "../Delivery";
import { formatMoneyInStringForm } from "../../util/helpers";
import DadosEntregaPedido from "../DadosEntregaPedido";
import TiposStatusPedido from "../../util/typesTipoStatusPedido";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "transparent" : "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: "center",
  boxShadow: "none",
  color: theme.palette.text.secondary,
}));

export default function DetalhePedidoSeguroViagem({ dadosPedido, isLoading }) {
  // seta fixamente
  const { user } = useAuth();
  const { showAlertSuccess, showAlertError } = useAlert();
  const classes = useStyles();
  const [openModalPagamento, setOpenModalPagamento] = useState(false);

  const handlerOpenModalPagamento = (e) => {
    setOpenModalPagamento(true);
  };

  const handlerCloseModalPagamento = (e) => {
    setOpenModalPagamento(false);
  };

  const handlerOpenUrlVoucher = (url) => (event) => {
    window.open(url, '_blank')

  }

  return (
    <>
      <Grid container >
        <Grid item xs={12}>
          {isLoading && <Skeleton width="auto" height={500} />}

          {!isLoading && (
            <List sx={{ width: "100%" }}>
              <Box className={classes.Detalhes}>
                <Box className={classes.TitleBox}>
                  <Typography
                    variant="h6"
                    sx={{
                      marginBottom: 1,
                      fontWeight: "bold",
                    }}
                  >
                    DETALHES DO PEDIDO
                    <span className={classes.Codigo}> #{dadosPedido?.id}</span>

                    <ListItem
                      secondaryAction={
                        <ListItemText
                          primary={format(
                            new Date(dadosPedido?.dataCadastro),
                            "dd/MM/yyyy"
                          )}
                        />
                      }
                      disablePadding
                    >
                      <ListItemText className={classes.Item}>
                        Data do pedido:
                      </ListItemText>
                    </ListItem>

                    <ListItem
                      secondaryAction={
                        <ListItemText
                          primary={format(
                            new Date(dadosPedido?.dataVigenciaDe),
                            "dd/MM/yyyy"
                          )}
                        />
                      }
                      disablePadding
                    >
                      <ListItemText className={classes.Item}>
                        Data de Vigência Inicio:
                      </ListItemText>
                    </ListItem>

                    <ListItem
                      secondaryAction={
                        <ListItemText
                          primary={format(
                            new Date(dadosPedido?.dataVigenciaAte),
                            "dd/MM/yyyy"
                          )}
                        />
                      }
                      disablePadding
                    >
                      <ListItemText className={classes.Item}>
                        Data de Vigência Final:
                      </ListItemText>
                    </ListItem>

                    <ListItem
                      secondaryAction={
                        <ListItemText
                          primary={dadosPedido?.seguroViagemDestino.descricao}
                        />
                      }
                      disablePadding
                    >
                      <ListItemText className={classes.Item}>
                        Destino:
                      </ListItemText>
                    </ListItem>

                  </Typography>
                </Box>
                {dadosPedido?.status.id === TiposStatusPedido.Concluido && (
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <CancelarPedidoCambio
                      idPedido={dadosPedido?.id}
                      idCliente={user.id}
                    />
                  </Box>
                )}
                <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

                  <Grid sx={{ width: "100%" }} item lg={12}>
                    <Item>
                      <Box className={classes.ItensPedido}>
                        <Typography className={classes.Titulo}>
                          Plano Escolhido
                        </Typography>

                        <Divider sx={{ mt: 1 }} />

                        <Fragment>
                          <List
                            sx={{
                              width: "100%",
                            }}
                          >
                            <ListItem
                              secondaryAction={
                                <ListItemText
                                  primary={dadosPedido.seguroViagem.codigo}
                                />
                              }
                              disablePadding
                            >

                              <ListItemText className={classes.Item}>
                                Código:
                              </ListItemText>

                            </ListItem>

                            <ListItem
                              secondaryAction={<ListItemText
                                primary={dadosPedido.seguroViagem.nome}
                              />}
                              disablePadding
                            >
                              <ListItemText className={classes.Item}>
                                Nome:
                              </ListItemText>
                            </ListItem>
                            <ListItem
                              secondaryAction={
                                <ListItemText
                                  primary={"R$ " + dadosPedido?.valorTotal}
                                />
                              }
                              disablePadding
                            >
                              <ListItemText className={classes.Item}>
                                Valor total:
                              </ListItemText>
                            </ListItem>

                            <ListItem
                              secondaryAction={
                                <ListItemText
                                  primary={dadosPedido.quantidadeDias}
                                />
                              }
                              disablePadding
                            >
                              <ListItemText className={classes.Item}>
                                Quantidade dias:
                              </ListItemText>
                            </ListItem>

                            {dadosPedido.seguroViagem.informacoesAdicionais !==
                              null && (
                                <ListItem
                                  secondaryAction={
                                    <ListItemText
                                      primary={
                                        dadosPedido.seguroViagem
                                          .informacoesAdicionais
                                      }
                                    />
                                  }
                                  disablePadding
                                >

                                  <ListItemText className={classes.Item}>
                                    Informações adicionais:
                                  </ListItemText>

                                </ListItem>
                              )}
                          </List>

                        </Fragment>
                      </Box>
                    </Item>
                  </Grid>
                  <Grid sx={{ width: "100%", mt: 1 }} item lg={12}>
                    <Item>
                      <Box className={classes.ItensPedido}>
                        <Typography className={classes.Titulo}>
                          Passageiros{" "}
                          <Badge
                            sx={{ ml: 2 }}
                            badgeContent={
                              dadosPedido && dadosPedido?.passageiros?.length
                            }
                            color="primary"
                          />
                        </Typography>

                        <Divider sx={{ mt: 1 }} />
                        {dadosPedido &&
                          dadosPedido?.passageiros?.map((passageiro, index) => (
                            <Fragment key={index}>
                              <List
                                sx={{
                                  width: "100%",
                                }}
                              >
                                <ListItem
                                  secondaryAction={
                                    <ListItemText primary={passageiro.nome} />
                                  }
                                  disablePadding
                                >
                                  <ListItemText className={classes.Item}>
                                    Nome:
                                  </ListItemText>
                                </ListItem>

                                <ListItem
                                  secondaryAction={
                                    <ListItemText
                                      primary={format(
                                        new Date(passageiro.dataNascimento),
                                        "dd/MM/yyyy"
                                      )}
                                    />
                                  }
                                  disablePadding
                                >
                                  <ListItemText className={classes.Item}>
                                    Data de nascimento:
                                  </ListItemText>
                                </ListItem>

                                {passageiro.numeroDocumentoIdentificacao !==
                                  null && (
                                    <ListItem
                                      secondaryAction={
                                        <ListItemText
                                          primary={
                                            passageiro.numeroDocumentoIdentificacao
                                          }
                                        />
                                      }
                                      disablePadding
                                    >

                                      <ListItemText className={classes.Item}>
                                        Nr. documento:
                                      </ListItemText>

                                    </ListItem>
                                  )}
                                {passageiro.telefone !== null && (
                                  <ListItem
                                    secondaryAction={<ListItemText
                                      primary={passageiro.telefone}
                                    />}
                                    disablePadding
                                  >

                                    <ListItemText className={classes.Item}>
                                      Telefone:
                                    </ListItemText>

                                  </ListItem>
                                )}

                                {!!passageiro.urlVoucher && (
                                  <ListItem
                                    secondaryAction={
                                      <ListItemText
                                        primary={
                                          <Link onClick={handlerOpenUrlVoucher(passageiro?.urlVoucher)} className={classes.link} >
                                            Voucher
                                          </Link>}
                                      />
                                    }
                                    disablePadding
                                  >

                                    <ListItemText className={classes.Item}>
                                      Acesse seu Voucher:
                                    </ListItemText>

                                  </ListItem>
                                )}

                                {!!passageiro.codigoVoucher && (
                                  <ListItem
                                    secondaryAction={
                                      <ListItemText
                                        primary={passageiro.codigoVoucher}
                                      />
                                    }
                                    disablePadding
                                  >
                                    <ListItemText className={classes.Item}>
                                      Codigo do Voucher:
                                    </ListItemText>
                                  </ListItem>
                                )}
                              </List>
                            </Fragment>
                          ))}
                      </Box>
                    </Item>

                    <Item sx={{ mt: 1 }}>
                      <List className={classes.formaPagamento}>
                        <Typography className={classes.Titulo}>
                          Forma de pagamento
                        </Typography>
                        <Divider sx={{ mt: 1 }}></Divider>
                        <ListItem sx={{ justifyContent: 'center' }}>
                          <ListItemText>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                              <FormasPagamentoSelecionado
                                pedido={dadosPedido}
                                isTodosDetalhes={false}
                                mostrarBotaoFinalizar={false}
                              />
                            </div>
                          </ListItemText>
                        </ListItem>
                      </List>
                    </Item>
                  </Grid>
                </Grid>
              </Box>
            </List>
          )}
        </Grid>
      </Grid>
    </>
  );
}
